/**
 * The wizard's nav bar for a step: Back on the left, an optional legend in the
 * middle, and the step's primary action(s) on the right — all in one aligned row.
 * Back is hidden on the first step (canGoBack false). Rendered at the TOP of a step
 * (placement="top", the default) so the primary action is reachable without
 * scrolling past a long schedule; pass placement="bottom" to anchor it below.
 */

import type { ReactNode } from 'react';

interface WizardFooterProps {
  onBack?: () => void;
  canGoBack?: boolean;
  legend?: ReactNode;
  /** Where the bar sits relative to the step body. Defaults to "top". */
  placement?: 'top' | 'bottom';
  /** The step's primary action button(s), rendered on the right. */
  children: ReactNode;
}

export function WizardFooter({
  onBack,
  canGoBack,
  legend,
  placement = 'top',
  children,
}: WizardFooterProps) {
  return (
    <div className={`wiz-foot${placement === 'top' ? ' wiz-foot--top' : ''}`}>
      {canGoBack && onBack && (
        <button
          type="button"
          className="wiz-btn"
          onClick={onBack}
          data-testid="wizard-back"
        >
          ← Back
        </button>
      )}
      {legend != null && <span className="wiz-legend">{legend}</span>}
      <div className="wiz-foot__primary">{children}</div>
    </div>
  );
}
